export const ERROR_MESSAGES: Record<string, string> = {
	ar: 'خطأ في الخادم',
	de: 'Serverfehler',
	en: 'Server error',
	es: 'Error del servidor',
	fa: 'خطای سرور',
	fr: 'Erreur du serveur',
	ja: 'サーバーエラー',
	kk: 'Сервер қатесі',
	ko: '서버 오류',
	pa: 'ਸਰਵਰ ਗਲਤੀ',
	pl: 'Błąd serwera',
	pt: 'Erro do servidor',
	ru: 'Ошибка сервера',
	tr: 'Sunucu hatası',
	uk: 'Помилка сервера',
	uz: 'Server xatosi',
	zh: '服务器错误',
};
